import React, { useState } from "react";
import FormulaRow from "../widgets/FormulaRow";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";

const FormulaTabContent = () => {
  const [formulas, setFormulas] = useState([{ id: Date.now() + "-f" }]);

  const addFormula = () => {
    setFormulas((prev) => [...prev, { id: Date.now() + "-f" }]);
  };

  const removeFormula = () => {
    if (formulas.length > 1) {
      setFormulas((prev) => prev.slice(0, -1));
    }
  };

  return (
    <>
      <div style={headerStyle}>
        <span style={labelStyle}>Formula</span>
        <div style={iconGroupStyle}>
          <button style={iconBtn} onClick={removeFormula}>
            <DeleteIcon style={muiIconStyle} />
          </button>
          <button style={iconBtn} onClick={addFormula}>
            <AddIcon style={muiIconStyle} />
          </button>
        </div>
      </div>

      <div style={columnLabelRow}>
        <div style={{ width: "70px" }}>Key</div>
        <div style={{ width: "280px" }}>Expression</div>
      </div>

      {formulas.map((item, index) => (
        <FormulaRow
          key={item.id}
          row={item}
          onChange={(newRow) => {
            const updated = [...formulas];
            updated[index] = newRow;
            setFormulas(updated);
          }}
        />
      ))}
    </>
  );
};

const headerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "6px",
};

const labelStyle = {
  fontWeight: "bold",
  color: "#00bcd4",
  fontSize: "14px",
};

const iconGroupStyle = {
  display: "flex",
  gap: "8px",
};

const iconBtn = {
  backgroundColor: "#2c2c2c",
  border: "1px solid #444",
  borderRadius: "5px",
  padding: "2px",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "24px",
  height: "24px",
};

const muiIconStyle = {
  fontSize: "12px",
  color: "white",
};

const columnLabelRow = {
  display: "flex",
  alignItems: "center",
  gap: "6px",
  marginBottom: "6px",
  fontSize: "12px",
  color: "#aaa",
  marginLeft: "12px",
};

export default FormulaTabContent;
